export const settingsConstants = {
    UPDATE_ERRORS_PROFILE: "UPDATE_ERRORS_PROFILE",
    CANCEL_EDIT_PROFILE: "CANCEL_EDIT_PROFILE",

    FETCH_USER_REQUEST: "USER_FETCH_REQUEST",
    FETCH_SUCCESS: "USER_FETCH_SUCCESS",
    FETCH_FAILURE: "USER_FETCH_FAILURE",
    FETCH_USER_SUCCESS: "USER_FETCH_SUCCESS",
    FETCH_USER_FAILURE: "USER_FETCH_FAILURE",

    IMAGE_UPLOAD_SUCCESS: "IMAGE_UPLOAD_SUCCESS",
    IMAGE_UPLOAD_FAILURE: "IMAGE_UPLOAD_FAILURE",

    MODIFY_DISPLAY_SETTINGS_REQUEST: "MODIFY_DISPLAY_SETTINGS_REQUEST",
    MODIFY_DISPLAY_SETTINGS_SUCCESS: "MODIFY_DISPLAY_SETTINGS_SUCCESS",
    MODIFY_DISPLAY_SETTINGS_FAILURE: "MODIFY_DISPLAY_SETTINGS_FAILURE",

    MODIFY_PRIVACY_SETTINGS_REQUEST: "MODIFY_PRIVACY_SETTINGS_REQUEST",
    MODIFY_PRIVACY_SETTINGS_SUCCESS: "MODIFY_PRIVACY_SETTINGS_SUCCESS",
    MODIFY_PRIVACY_SETTINGS_FAILURE: "MODIFY_PRIVACY_SETTINGS_FAILURE",
};
